export default {
    data: () => ({
        translations: {
            createTitle: {
                el: "Νέα Ομάδα Προϊόντων",
                en: "New Product Group",
                it: "Nuovo gruppo di prodotti"
            },
            updateTitle: {
                el: "",
                en: "Update Product Group",
                it: ""
            },
            productGroupName: {
                el: "Όνομα Ομάδας Προϊόντων",
                en: "Product Group Name",
                it: "Nome del gruppo di prodotti "
            },
            productGroupDescription: {
                el: "Περιγραφή Ομάδας Προϊόντων",
                en: "Product Group Description",
                it: "Descrizione del gruppo di prodotti"
            },
            prices: {
                el: "Τιμές",
                en: "Prices",
                it: "Prezzi"
            },
            sellingPrice: {
                el: "Τιμή Πώλήσης",
                en: "Selling Price",
                it: "Prezzo di vendita"
            },
            wholesalePrice: {
                el: "Τιμή Χονδρικής",
                en: "Wholesale Price",
                it: "Prezzo all'ingrosso"
            },
            selectCategory: {
                el: "Επίλεξε Κατηγορία",
                en: "Select Category",
                it: "Scegliere la categoria"
            },
            imageCheckbox: {
                el: "Θέλω να εμφανίζεται η ομάδα προϊόντων με φωτογραφία στην εφαρμογή",
                en:
                    "I want the product group to be displayed with an image in the application",
                it: "Voglio visualizzare il gruppo di prodotti con una foto nell'app"
            },
            imageTitle: {
                el: "Εικόνα Ομάδας Προϊόντων (προαιρετικό)",
                en: "Product Group Image (optional)",
                it: "Immagine del gruppo di prodotti (opzionale)"
            },
            daysCheckbox: {
                el: "Θέλω να εμφανίζεται η ομάδα  προϊόντων σε συγκεκριμένες μέρες",
                en: "I want the product group to be displayed on specific days",
                it: "Voglio che il gruppo di prodotti appaia in giorni specifici"
            },
            daysInfo: {
                el: "Επίλεξε τις ημέρες που θέλετε να εμφανίζεται το προϊόν στο κοινό",
                en: "Choose the days you want the product to be displayed in public",
                it: "Scegli i giorni in cui vuoi che il prodotto sia esposto in pubblico"
            },
            published: {
                el: "Προϊόν ορατό στο κοινό",
                en: "Published",
                it: "Prodotto visibile al pubblico"
            }
        }
    })
};
